import api from '../../api/accommodation';

const state = {
  accommodations: {},
  // Whether `accommodations` can be trusted as an answer for `accommodationsRideId`,
  // and for which ride it is: 'idle' (never fetched), 'loading', 'ready' or 'error'.
  // A component that needs to know "has this actually been fetched for THIS ride"
  // (not just "is the value non-empty") must compare accommodationsRideId to its
  // own ride id -- the value alone can't tell a never-fetched ride apart from one
  // that genuinely has no stays, since the server answers `{}` for both
  // (accommodation/views.py:555 drops every key whose list is empty).
  accommodationsStatus: 'idle',
  accommodationsRideId: null,
};
const getters = {
  allAccommodations: state => state.accommodations,
  accommodationsStatus: state => state.accommodationsStatus,
  accommodationsRideId: state => state.accommodationsRideId,
};
const actions = {
  async fetchAccommodations({ rootState, commit }) {
    const { apptoken } = rootState.appauth;
    const rideId = rootState.ride.lowedRideId
    // We should condsider whuch value we wont to use , at the next step the other is a god option
    // const rideId = rootState.ride.rideId;
    commit('setAccommodationsLoading', rideId);
    try {
      const response = await api.fetchAccommodationsTemp(apptoken, rideId);
      commit('setAccommodations', { rideId, accommodations: response.data });
    } catch (err) {
      commit('setAccommodationsError', rideId);
      throw err;
    }
    // await dispatch('rideUpdateMarkerByScrollerLocation');

  },
    // var palannedDate = new Date(ride.ride.attractionsByDay[originalDayIndex].dateTime);
    // palannedDate.setHours(23,59);
    // commit('setSerchPlannedDate', palannedDate.toLocaleString("en-US"));
};

const mutations = {
  setAccommodationsLoading: (state, rideId) => {
    state.accommodationsRideId = rideId;
    state.accommodationsStatus = 'loading';
  },
  setAccommodations: (state, { rideId, accommodations }) => {
    state.accommodations = accommodations;
    state.accommodationsRideId = rideId;
    state.accommodationsStatus = 'ready';
  },
  setAccommodationsError: (state, rideId) => {
    state.accommodationsRideId = rideId;
    state.accommodationsStatus = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
